export const CvParsedEnglish = {
  education: 'Education',
  grade: 'Grade: {grade}',
  percentage: 'Percentage: {percentage}%',
  industry: 'Industry',
  languages: 'Languages',
  skills: 'Skills',
  workExperience: 'Work experience',
  location: 'Location',
  aiParsedCvData: 'AI parsed CV data',
  parsingInProgress: 'The AI is currently parsing candidate CV data. Please check back later.',
  bulkParseCVsTitle: 'Bulk Parse CVs ({selectedCount})',
  selectedCVsText: 'This will parse the {selectedCount} selected CVs. You can view the parsed data in their profiles once the parsing is complete.',
  selectedCVTextWithCredits: 'Only {canBeParsed} out of {totalSelected} CVs can be parsed due to limited AI scoring and parsing credits.',
  parseCVsButtonText: 'Parse CVs ({selectedCount})',
  parsingInProgressText: 'CV parsing is in progress. This may take a few minutes.',
  scoringAndParsingTitle: 'AI Scoring and parsed CV data',
  scoringAndParsingMessage: 'Unable to generate the CV score and parse the CV.',
  scoringAndParsingButtonText: 'Click here to retry',
  cvParsingInProgressMessage: 'CV parsing is currently in progress. Please retry after a few minutes.',
  refreshButton: 'Refresh',
  cvParsingFailedMessage: 'Unable to parse the CV.',
  retryButton: 'Retry',
  noteText: 'Note: CV Parsing may take a few minutes.',
  inSufficientCredits: 'Unable to parse CV because you’ve run out of AI Parsing and Scoring credits.',
  addMoreCredits: 'Add more credits',
  scoringAndParsingInSufficientCreditsMessage: 'Unable to generate the CV score and parse the CV because you’ve run out of AI Parsing and Scoring credits.'
}

export const CvParsedArabic = {
  education: 'تعليم',
  grade: 'الدرجة: {grade}',
  percentage: 'النسبة المئوية: {percentage}%',
  industry: 'صناعة',
  languages: 'لغات',
  skills: 'مهارات',
  workExperience: 'الخبرة العملية',
  location: 'موقع',
  aiParsedCvData: 'البيانات المستخرجة من السيرة الذاتية باستخدام الذكاء الاصطناعي',
  parsingInProgress: 'يقوم الذكاء الاصطناعي حاليًا بمعالجة بيانات السيرة الذاتية للمرشح. يرجى التحقق لاحقًا.',
  bulkParseCVsTitle: 'تحليل السير الذاتية بالجملة ({selectedCount})',
  selectedCVsText: 'سيتم تحليل {selectedCount} سير ذاتية تم اختيارها. يمكنك عرض البيانات المحللة في ملفاتهم الشخصية بمجرد اكتمال التحليل.',
  selectedCVTextWithCredits: 'يمكن معالجة {canBeParsed} فقط من أصل {totalSelected} سير ذاتية بسبب محدودية أرصدة تحليل الدرجات باستخدام الذكاء الاصطناعي.',
  parseCVsButtonText: 'تحليل السير الذاتية ({selectedCount})',
  parsingInProgressText: 'جاري تحليل السير الذاتية. قد يستغرق ذلك بضع دقائق.',
  scoringAndParsingTitle: 'التقييم باستخدام الذكاء الاصطناعي وبيانات السير الذاتية المحللة',
  scoringAndParsingMessage: 'تعذر توليد التقييم للسيرة الذاتية وتحليل السيرة الذاتية.',
  scoringAndParsingButtonText: 'اضغط هنا لإعادة المحاولة',
  cvParsingInProgressMessage: 'جاري تحليل السيرة الذاتية حالياً. يرجى المحاولة بعد بضع دقائق.',
  refreshButton: 'تحديث',
  cvParsingFailedMessage: 'تعذر تحليل السيرة الذاتية.',
  retryButton: 'إعادة المحاولة',
  noteText: 'ملاحظة: قد يستغرق تحليل السيرة الذاتية بضع دقائق.',
  inSufficientCredits: 'تعذر تحليل السيرة الذاتية لأنك نفدت الائتمانات الخاصة بتحليل وتقييم الذكاء الاصطناعي.',
  addMoreCredits: 'إضافة المزيد من الائتمانات',
  scoringAndParsingInSufficientCreditsMessage: 'تعذر إنشاء درجة السيرة الذاتية وتحليل السيرة الذاتية لأنك نفدت الائتمانات الخاصة بتحليل وتقييم الذكاء الاصطناعي.'
}
